/**
 * Resets the redux file-upload slice on unmount so a leftover
 * `downloadURL` / `progress === 100` from a previous session can't
 * trigger the post-upload submit effect when this page is re-mounted.
 *
 * @module pharmaQuestionaire/hooks/useFileUploadCleanup
 */
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { resetFileUploadState } from "../../../redux/slice/fileUploadSliceNew";
import { AppDispatch } from "../../../redux/store/store";

export const useFileUploadCleanup = (): void => {
  const dispatch = useDispatch<AppDispatch>();
  useEffect(() => {
    return () => {
      dispatch(resetFileUploadState());
    };
  }, [dispatch]);
};
